(function () {
  // Util: safe phone for tel:
  function normalizePhone(p) {
    return (p || "").toString().replace(/\s+/g, "").replace(/[^\d+]/g, "");
  }

  // Util: compute a sensible center from all stores
  function getCenter(stores) {
    if (!stores.length) return { lat: 50.671345, lng: -4.19016 }; // fallback
    var sumLat = 0, sumLng = 0, count = 0;
    stores.forEach(function (s) {
      var lat = parseFloat(s.lat), lng = parseFloat(s.lng);
      if (!isNaN(lat) && !isNaN(lng)) { sumLat += lat; sumLng += lng; count++; }
    });
    return count ? { lat: sumLat / count, lng: sumLng / count } : { lat: 50.671345, lng: -4.19016 };
  }

  // Expose the REAL init that Google should run (via the shim in Liquid)
  window.__rolexRealInitMap = function () {
    var mapElement = document.getElementById('rolex-contact-map');
    if (!mapElement) return;

    // 1) Parse dynamic data emitted by Liquid
    var stores = [];
    var dataEl = document.getElementById('rolex-stores-data');
    if (dataEl && dataEl.textContent.trim()) {
      try { stores = JSON.parse(dataEl.textContent); } catch (e) { console.warn('[Rolex Map] Bad JSON', e); }
    }

    // 2) Map options
    var centerLocation = getCenter(stores);
    var mapOptions = {
      zoom: 10,
      center: centerLocation,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false,
      disableDefaultUI: true,
      styles: [
        {"elementType":"geometry","stylers":[{"color":"#f9f8f8"}]},
        {"elementType":"labels.icon","stylers":[{"visibility":"off"}]},
        {"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},
        {"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},
        {"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},
        {"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},
        {"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},
        {"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#d3e0d4"}]},
        {"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},
        {"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},
        {"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},
        {"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dddfe2"}]},
        {"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},
        {"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},
        {"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},
        {"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},
        {"featureType":"water","elementType":"geometry","stylers":[{"color":"#c6d8e0"}]},
        {"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}
      ]
    };

    // 3) Create the map
    var map = new google.maps.Map(mapElement, mapOptions);

    // 4) Icons
    var markerIcons = {
      retailer: {
        default: 'https://cdn.shopify.com/s/files/1/0063/4883/2856/files/map-location-pin-green-button.svg?v=1778226756',
        selected: 'https://cdn.shopify.com/s/files/1/0063/4883/2856/files/map-location-pin-selected-green-button.svg?v=1778226755'
      },
      preowned: {
        default: 'https://cdn.shopify.com/s/files/1/0063/4883/2856/files/map-location-pin-black-button.svg?v=1778226756',
        selected: 'https://cdn.shopify.com/s/files/1/0063/4883/2856/files/map-location-pin-selected-black-button.svg?v=1778226756'
      }
    };
    var markerSize = new google.maps.Size(40, 40);
    
    // 5) DOM references
    var showroomDetailsDiv = document.getElementById('showroom-details');
    var container = document.querySelector('.contact-component-container');
    var storeCards = Array.prototype.slice.call(document.querySelectorAll('.r7-item-card[data-store-index]'));
    var markers = [];
    var markerGroups = {
      retailer: [],
      preowned: []
    };
    var markersByStoreIndex = {
      retailer: {},
      preowned: {}
    };
    var activeMarker = null;
    var boundsByType = {
      retailer: new google.maps.LatLngBounds(),
      preowned: new google.maps.LatLngBounds()
    };
    var activeStoreType = 'retailer';

    function isMobileMap() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }

    // Ensure no store is selected by default:
    showroomDetailsDiv.innerHTML = '';
    showroomDetailsDiv.classList.remove('active');
    if (container) container.classList.remove('showroom-details-active');

    function getStoreCards(index) {
      return storeCards.filter(function (card) {
        return card.getAttribute('data-store-index') === String(index);
      });
    }

    function clearActiveCards() {
      storeCards.forEach(function (card) {
        card.classList.remove('is-active', 'is-hovered');
      });
    }

    function setActiveCard(index, shouldScroll) {
      clearActiveCards();
      var cards = getStoreCards(index);
      cards.forEach(function (card) {
        card.classList.add('is-active');
      });

      if (shouldScroll && cards[0]) {
        var visibleCard = cards.find(function (card) {
          return card.offsetParent !== null;
        }) || cards[0];
        visibleCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function setHoveredCard(index, isHovered) {
      getStoreCards(index).forEach(function (card) {
        card.classList.toggle('is-hovered', isHovered);
      });
    }

    function getMarkerIcon(marker, state) {
      var type = marker && marker.rolexType === 'preowned' ? 'preowned' : 'retailer';
      return {
        url: markerIcons[type][state || 'default'],
        scaledSize: markerSize
      };
    }

    function getMapPadding() {
      var panelWidth = 0;
      if (window.matchMedia('(min-width: 1025px)').matches && container && !container.classList.contains('sidebar-hidden')) {
        panelWidth = 440;
      }

      return {
        top: 90,
        right: 90,
        bottom: 90,
        left: panelWidth + 90
      };
    }

    function focusMarker(marker) {
      map.panTo(marker.getPosition());
      map.setZoom(18);

      if (window.matchMedia('(min-width: 1025px)').matches && container && !container.classList.contains('sidebar-hidden')) {
        window.setTimeout(function () {
          map.panBy(-220, 0);
        }, 120);
      }
    }

    function closeDetails(options) {
      options = options || {};
      var selectedMarker = activeMarker;
      showroomDetailsDiv.classList.remove('active');
      if (container) {
        container.classList.remove('showroom-details-active');
      }
      clearActiveCards();
      markers.forEach(function (m) {
        var keepSelectedIcon = isMobileMap() && selectedMarker && m === selectedMarker && !options.preserveMap;
        m.setIcon(getMarkerIcon(m, keepSelectedIcon ? 'selected' : 'default'));
        m.setZIndex(null);
      });
      activeMarker = null;
      if (isMobileMap() && selectedMarker && !options.preserveMap) {
        selectedMarker.setZIndex(999);
        activeMarker = selectedMarker;
        map.panTo(selectedMarker.getPosition());
        map.setZoom(18);
        return;
      }
      if (!options.preserveMap) {
        focusVisibleMarkers();
      }
    }
    window.__rolexCloseMapDetails = closeDetails;

    function getVisibleMarkers() {
      return markerGroups[activeStoreType] || [];
    }

    function focusVisibleMarkers() {
      var visibleMarkers = getVisibleMarkers();

      if (visibleMarkers.length === 1) {
        map.panTo(visibleMarkers[0].getPosition());
        map.setZoom(isMobileMap() ? 12 : 18);
        return;
      }

      if (visibleMarkers.length > 1) {
        var visibleBounds = new google.maps.LatLngBounds();
        visibleMarkers.forEach(function (marker) {
          visibleBounds.extend(marker.getPosition());
        });
        map.fitBounds(visibleBounds, getMapPadding());
        return;
      }

      map.setCenter(centerLocation);
      map.setZoom(10);
    }

    function applyStoreTypeFilter(type) {
      activeStoreType = type || 'retailer';
      closeDetails();

      markers.forEach(function (marker) {
        marker.setVisible(marker.rolexType === activeStoreType);
      });

      focusVisibleMarkers();
    }

    // 6) Build markers from dynamic stores
    stores.forEach(function (s, index) {
      var lat = parseFloat(s.lat), lng = parseFloat(s.lng);
      if (isNaN(lat) || isNaN(lng)) return;
      var position = { lat: lat, lng: lng };

      function createStoreMarker(type) {
        var marker = new google.maps.Marker({
          position: position,
          map: map,
          title: s.title || '',
          icon: {
            url: markerIcons[type].default,
            scaledSize: markerSize
          },
          zIndex: 1,
          visible: type === activeStoreType
        });
        marker.rolexStore = s;
        marker.rolexStoreIndex = index;
        marker.rolexType = type;

        marker.addListener('click', function () {
        // reset icons
        markers.forEach(function (m) {
          m.setIcon(getMarkerIcon(m, 'default'));
          m.setZIndex(1);
        });
        marker.setIcon(getMarkerIcon(marker, 'selected'));
        marker.setZIndex(999);
        activeMarker = marker;
        setActiveCard(index, true);
        focusMarker(marker);

        // phone normalization for tel:
        var tel = normalizePhone(s.phone);

        var tagsHtml = '';
        var titleCount = 0;

        if (s.showTagOne) titleCount++;
        if (s.showTagTwo) titleCount++;
        if (s.showTagThree) titleCount++;

        if (titleCount > 0) {
          tagsHtml += '<div class="retailer-titles ' + (titleCount > 1 ? 'is-flex' : '') + '">';

          if (s.showTagOne) {
            tagsHtml += '<span class="active">' + (s.tagOne || '') + '</span>';
          }

          if (s.showTagTwo) {
            tagsHtml += '<span>' + (s.tagTwo || '') + '</span>';
          }

          if (s.showTagThree) {
            tagsHtml += '<span class="service">' + (s.tagThree || '') + '</span>';
          }

          tagsHtml += '</div>';
        }

// STEP 1: weekly parse
var weekly = {};
try {
  weekly = JSON.parse(s.weeklyTiming || '{}');
} catch(e) {}

// STEP 2: days setup
var days = [
  { key: 'mon', label: 'Monday' },
  { key: 'tue', label: 'Tuesday' },
  { key: 'wed', label: 'Wednesday' },
  { key: 'thu', label: 'Thursday' },
  { key: 'fri', label: 'Friday' },
  { key: 'sat', label: 'Saturday' },
  { key: 'sun', label: 'Sunday' }
];

// STEP 3: today
var todayKey = ['sun','mon','tue','wed','thu','fri','sat'][new Date().getDay()];

// STEP 4: format function (AM/PM)
function formatTimeRange(range) {
  if (!range || range.toLowerCase() === 'closed') return 'Closed';

  if (/[ap]m/i.test(range)) return range;

  var parts = range.split('-');
  if (parts.length !== 2) return range;

  function format(t) {
    var [h, m] = t.split(':');
    h = parseInt(h, 10);

    var ampm = h >= 12 ? 'pm' : 'am'; // lowercase for design
    h = h % 12 || 12;

    return h + ':' + (m || '00') + ampm;
  }

  return format(parts[0]) + ' - ' + format(parts[1]);
}

// STEP 5: today time + status
var todayTimeRaw = weekly[todayKey] || 'Closed';
var todayTime = formatTimeRange(todayTimeRaw);
var isClosed = todayTime.toLowerCase().includes('closed');
var statusText = isClosed ? 'Currently closed' : 'Currently open';

// STEP 6: build list UI (IMPORTANT)
var timingHtml = '<div class="store-detail-timing">';
timingHtml += `<div class="status-text">${statusText}</div>`;

days.forEach(function(day){
  var raw = weekly[day.key] || 'Closed';
  var time = formatTimeRange(raw);

  timingHtml += `
    <div class="timing-row ${day.key === todayKey ? 'active-day' : ''}">
      <span class="day">${day.label}</span>
      <span class="time">${time}</span>
    </div>
  `;
});

timingHtml += '</div>';
        

        // details HTML (addressHtml is authored by you in admin)
        showroomDetailsDiv.innerHTML = '\
          <div>\
            <div class="showroom-details-img">\
              ' + (s.image ? ('<img src="' + s.image + '" alt="' + (s.title || '') + '">') : '') + '\
              <span class="close-icon">\
                <svg class="block h-[10px] w-[10px]" height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true"><path d="m13.27 0-5.77 5.77-5.77-5.77-1.73 1.73 5.77 5.77-5.77 5.77 1.73 1.73 5.77-5.77 5.77 5.77 1.73-1.73-5.77-5.77 5.77-5.77z"></path></svg>\
              </span>\
            </div>\
            <div class="showroom-details-content">\
              ' + tagsHtml + '\
              <h3>' + (s.title || '') + '</h3>\
              <div>' + (s.addressHtml || '') + '</div>\
              ' + timingHtml + '\
              <ul class="showroom-details-linking">\
                <li class="calltrack">\
                  <a href="' + (tel ? ('tel:' + tel) : '#') + '" class="rolex-contact-phone">\
                    <span class="svg"><svg height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true"><path d="m4.84 4.97-.08.03c.54 1.9 1.63 4.09 3.76 6.08l.16-.14c.83-.73 2.06-.88 2.75-.33l1.21 1.07c.67.54.65 1.5-.13 2.24-.42.49-3.43 3.57-7.98-3.6-4.77-7.56-1.9-9.63-.66-10.15.02-.01.04-.01.06-.02.03-.01.07-.02.1-.04.01 0 .03-.01.04-.01.18-.06.29-.08.29-.08s0 0 0 .01c.82-.15 1.49.25 1.74.92 0 0 1.13 3.4-1.26 4.02z"></path></svg></span>\
                    <span>' + (s.phone || '') + '</span>\
                  </a>\
                </li>\
                <li class="dirtrack">\
                  <a href="' + (s.mapLink || '#') + '" target="_blank" class="rolex-contact-store">\
                    <span class="svg"><svg height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true"><path d="m0 8.77 15-8.77-7.64 15-1.98-5.09z"></path></svg></span>\
                    <span>Get directions</span>\
                  </a>\
                </li>\
                <li>\
                  <a href="' + (s.messageLink || '#') + '">\
                    <span class="svg">\
                      <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">\
                        <path id="icons_x2F_mail" d="M0,1.5h15v0.1L7.6,7.3L0,1.5z M7.6,9.5L0,3.8v9.7h15V3.9L7.6,9.5z"></path>\
                      </svg>\
                    </span>\
                    <span>' + (s.messageText || 'Send us a message') + '</span>\
                  </a>\
                </li>\
                <li class="store_more_details">\
                  <a href="' + (s.detailsLink || '#') + '" class="bespoke-primary">\
                    <span>More details</span>\
                    <span class="svg"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Calque_1" x="0px" y="0px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve"><path d="M12,7.5l-1.3,1.4L4.6,15l-1.5-1.5l6.1-6.1L3,1.4L4.5,0l6.1,6.1l0,0L12,7.5z"></path></svg></span>\
                  </a>\
                </li>\
              </ul>\
            </div>\
          </div>';

        showroomDetailsDiv.classList.add('active');
        if (container) {
          container.classList.add('showroom-details-active');
          container.classList.remove('sidebar-hidden');
        }
        var closer = showroomDetailsDiv.querySelector('.close-icon');
        if (closer) {
          closer.addEventListener('click', function () {
            closeDetails();
          }, { once: true });
        }
        });

        marker.addListener('mouseover', function () {
          if (marker.rolexType !== activeStoreType) return;
          marker.setZIndex(1000);
          if (marker !== activeMarker) marker.setIcon(getMarkerIcon(marker, 'selected'));
          setHoveredCard(index, true);
        });

        marker.addListener('mouseout', function () {
          if (marker.rolexType !== activeStoreType) return;
          if (marker !== activeMarker) {
            marker.setIcon(getMarkerIcon(marker, 'default'));
            marker.setZIndex(1);
          }
          setHoveredCard(index, false);
        });

        markers.push(marker);
        markerGroups[type].push(marker);
        markersByStoreIndex[type][index] = marker;
        boundsByType[type].extend(position);
      }

      if (s.showRetailer !== false) createStoreMarker('retailer');
      if (s.showPreowned) createStoreMarker('preowned');
    });

    focusVisibleMarkers();

    storeCards.forEach(function (card) {
      var index = parseInt(card.getAttribute('data-store-index'), 10);

      card.addEventListener('mouseenter', function () {
        var marker = markersByStoreIndex[activeStoreType][index];
        if (!marker) return;
        marker.setZIndex(1000);
        if (marker !== activeMarker) marker.setIcon(getMarkerIcon(marker, 'selected'));
      });

      card.addEventListener('mouseleave', function () {
        var marker = markersByStoreIndex[activeStoreType][index];
        if (!marker) return;
        if (marker !== activeMarker) {
          marker.setIcon(getMarkerIcon(marker, 'default'));
          marker.setZIndex(1);
        }
      });

      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        var marker = markersByStoreIndex[activeStoreType][index];
        if (!marker) return;
        google.maps.event.trigger(marker, 'click');
      });
    });

    map.addListener('click', function () {
      closeDetails();
    });

    document.querySelectorAll('.r7-contact-tabs a[href="#retailer"], .r7-contact-tabs a[href="#preowned"]').forEach(function (tabLink) {
      tabLink.addEventListener('click', function () {
        var type = tabLink.getAttribute('href') === '#preowned' ? 'preowned' : 'retailer';
        setTimeout(function () {
          applyStoreTypeFilter(type);
        }, 0);
      });
    });

    var currentActiveTab = document.querySelector('.r7-contact-tabs a.r7-tab-active');
    if (currentActiveTab && currentActiveTab.getAttribute('href') === '#preowned') {
      applyStoreTypeFilter('preowned');
    } else {
      applyStoreTypeFilter('retailer');
    }

    // IMPORTANT CHANGE: Do NOT auto-open any store on initial load.
    // (Removed the previous: google.maps.event.trigger(markers[0], 'click');)

    // Handle container visibility / resize issues (e.g., tab switches)
    function safeResize() {
      google.maps.event.trigger(map, 'resize');
      if (activeMarker) {
        map.panTo(activeMarker.getPosition());
      } else if (!boundsByType[activeStoreType].isEmpty()) {
        focusVisibleMarkers();
      } else {
        map.setCenter(centerLocation);
      }
    }
    window.addEventListener('resize', function () { safeResize(); });

    // If tabs hide/show #tab-map, a small timeout helps once it becomes visible
    setTimeout(safeResize, 150);
  };

  // If Google already called initMap before this file loaded, drain the queue.
  if (window.__rolexInitQueue && window.__rolexInitQueue.length) {
    window.__rolexInitQueue = [];
    if (typeof window.__rolexRealInitMap === 'function') {
      window.__rolexRealInitMap();
    }
  }
})();

document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.getElementById("retailer-list-toggle");
    const container = document.querySelector(".contact-component-container");
    if (!toggleBtn || !container) return;

    toggleBtn.addEventListener("click", function () {
        const showroomDetails = document.getElementById("showroom-details");
        if (showroomDetails && showroomDetails.classList.contains("active")) {
          container.classList.add("sidebar-hidden");
          window.setTimeout(function () {
            if (typeof window.__rolexCloseMapDetails === "function") {
              window.__rolexCloseMapDetails({ preserveMap: true });
            } else {
              showroomDetails.classList.remove("active");
              container.classList.remove("showroom-details-active");
            }
          }, 620);
          return;
        }

        container.classList.toggle("sidebar-hidden");
        if (container.classList.contains("sidebar-hidden")) {
          container.classList.remove("showroom-details-active");
        }
    });
});
